import React, { useState } from 'react';
import { FaOptionIcon } from '@europrocurement/l2d-icons';
import { Box, IconButton, Menu, MenuItem, Typography, useTheme } from '@mui/material';
import { DossierObjectGroup, DOSSIERS_OPEN_SEARCH_SLICE_NAME } from '@europrocurement/l2d-domain';
import { useNavigate } from 'react-router-dom';

import { faEdit, faEye, faTrash } from '@fortawesome/sharp-solid-svg-icons';
import { useDispatch } from 'react-redux';
import { useFullLayout } from '@europrocurement/flexy-components/components/templates/FullLayout/FullLayoutContext';
import { useDossierGroupeActionDispatch } from '../../../providers/DossierGroupeActionProvider';
import { dossiersBasePath } from '../../../constants';

export type ActionMenuListeDossierProps = {
    dossierGroupe: DossierObjectGroup;
};

const ActionMenuListeDossierGroup: React.FunctionComponent<ActionMenuListeDossierProps> =
    function ({ dossierGroupe }) {
        const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
        const open = Boolean(anchorEl);
        const navigate = useNavigate();
        const dispatch = useDispatch();
        const { palette } = useTheme();
        const modalDispatch = useDossierGroupeActionDispatch();
        const { setCustomizerDrawerOpen } = useFullLayout();

        const handleClick = (event: React.MouseEvent<HTMLElement>) => {
            setAnchorEl(event.currentTarget);
        };

        const handleClose = () => {
            setAnchorEl(null);
        };

        const handleOpenDossierGroupModal: (action: 'edit' | 'delete') => void = (action) => {
            if (modalDispatch) {
                modalDispatch({ type: action, payload: dossierGroupe });
            }
            setAnchorEl(null);
        };

        // dispatch groupId to the dossier store and navigate to the dossier list
        const handleListDossierLinkClick = () => {
            dispatch({
                type: `${DOSSIERS_OPEN_SEARCH_SLICE_NAME}/setmainFilter`,
                payload: {
                    key: 'groupId',
                    value: dossierGroupe.id,
                },
            });
            setCustomizerDrawerOpen(false);
            navigate(`/${dossiersBasePath}`);
        };

        return (
            <div
                onClick={(e) => {
                    e.stopPropagation();
                }}
                onKeyDown={() => {}}
                role="button"
                tabIndex={0}
            >
                <IconButton
                    aria-label="more"
                    id="long-button"
                    aria-controls={open ? 'long-menu' : undefined}
                    aria-expanded={open ? 'true' : undefined}
                    aria-haspopup="true"
                    onClick={handleClick}
                >
                    <FaOptionIcon
                        icon={['fasl', 'ellipsis-vertical']}
                        sx={{ fontSize: '1rem' }}
                    />
                </IconButton>
                <Menu
                    id="long-menu"
                    MenuListProps={{
                        'aria-labelledby': 'long-button',
                    }}
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                >
                    <MenuItem>
                        <Box
                            sx={{ display: 'flex', gap: '4px' }}
                            onClick={handleListDossierLinkClick}
                        >
                            <FaOptionIcon
                                icon={faEye}
                                sx={{ color: 'text.gris50' }}
                            />
                            <Typography variant="l2dbodys"> Voir les dossiers</Typography>
                        </Box>
                    </MenuItem>
                    <MenuItem>
                        <Box
                            sx={{ display: 'flex', gap: '4px' }}
                            onClick={() => handleOpenDossierGroupModal('edit')}
                        >
                            <FaOptionIcon
                                icon={faEdit}
                                sx={{ color: 'text.gris50' }}
                            />
                            <Typography variant="l2dbodys">Editer le groupe</Typography>
                        </Box>
                    </MenuItem>
                    <MenuItem>
                        <Box
                            sx={{ display: 'flex', gap: '4px' }}
                            onClick={() => handleOpenDossierGroupModal('delete')}
                        >
                            <FaOptionIcon
                                icon={faTrash}
                                sx={{ fontSize: '1rem', color: palette.error.main }}
                            />
                            <Typography
                                variant="l2dbodys"
                                sx={{ color: palette.error.main }}
                            >
                                Supprimer
                            </Typography>
                        </Box>
                    </MenuItem>
                </Menu>
            </div>
        );
    };

export default ActionMenuListeDossierGroup;
